export default __webpack_public_path__ + "static/media/shootings.fb712dd3.jpg";